import React, { useState } from 'react';
import './App.css';
import { PIPEDRIVE_CONFIG } from './config';

// Componente Modal para Formulário de Captura
const LeadCaptureModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nome.trim()) {
      newErrors.nome = 'Nome é obrigatório';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }
    
    if (!formData.telefone.trim()) {
      newErrors.telefone = 'Telefone é obrigatório';
    } else if (!/^\(\d{2}\)\s\d{4,5}-\d{4}$/.test(formData.telefone)) {
      newErrors.telefone = 'Telefone inválido (formato: (11) 99999-9999)';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'telefone') {
      // Formatar telefone automaticamente
      const formatted = value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
      setFormData(prev => ({ ...prev, [name]: formatted }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    
    // Limpar erro do campo quando usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const sendToPipedrive = async (formData) => {
    const pipedriveData = {
      name: formData.nome,
      email: [
        {
          value: formData.email,
          primary: true,
          label: "work"
        }
      ],
      phone: [
        {
          value: formData.telefone,
          primary: true,
          label: "work"
        }
      ]
    };

    try {
      const response = await fetch(`${PIPEDRIVE_CONFIG.BASE_URL}/persons`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'x-api-token': PIPEDRIVE_CONFIG.API_KEY
        },
        body: JSON.stringify(pipedriveData)
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Lead enviado para Pipedrive com sucesso:', result);
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        throw new Error(`Erro na API do Pipedrive: ${errorData.error || 'Erro desconhecido'}`);
      }
    } catch (error) {
      console.error('Erro ao enviar para Pipedrive:', error);
      return { success: false, error: error.message };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    
    try {
      // Enviar para Pipedrive
      const result = await sendToPipedrive(formData);
      
      if (result.success) {
        setIsSubmitted(true);
        onSubmit(formData);
      } else {
        // Mostrar erro para o usuário
        setErrors({ 
          submit: 'Erro ao processar inscrição. Tente novamente ou entre em contato conosco.' 
        });
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
      setErrors({ 
        submit: 'Erro ao processar inscrição. Tente novamente ou entre em contato conosco.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setFormData({ nome: '', email: '', telefone: '' });
      setErrors({});
      setIsSubmitted(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose} disabled={isSubmitting}>
          ×
        </button>
        
        {!isSubmitted ? (
          <>
            <div className="modal-header">
              <h2 className="title-md">Quero meu Investe AI Gratuito</h2>
              <p className="text-base">Preencha seus dados e tenha acesso gratuito ao seu assistente de investimentos no WhatsApp.</p>
            </div>
            
            <form onSubmit={handleSubmit} className="lead-form">
              <div className="form-group">
                <label htmlFor="nome">Nome Completo *</label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  className={errors.nome ? 'error' : ''}
                  placeholder="Seu nome completo"
                  disabled={isSubmitting}
                />
                {errors.nome && <span className="error-message">{errors.nome}</span>}
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className={errors.email ? 'error' : ''}
                  placeholder="seu@email.com"
                  disabled={isSubmitting}
                />
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>
              
              <div className="form-group">
                <label htmlFor="telefone">Telefone *</label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleInputChange}
                  className={errors.telefone ? 'error' : ''}
                  placeholder="(11) 99999-9999"
                  maxLength="15"
                  disabled={isSubmitting}
                />
                {errors.telefone && <span className="error-message">{errors.telefone}</span>}
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary btn-large form-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner"></span>
                    Enviando...
                  </>
                ) : (
                  'Acessar Gratuitamente'
                )}
              </button>
              
              {errors.submit && (
                <div className="error-message submit-error">
                  {errors.submit}
                </div>
              )}
            </form>
          </>
        ) : (
          <div className="success-message">
            <div className="success-icon">✅</div>
            <h2 className="title-md">Parabéns! Você tem acesso gratuito!</h2>
            <p className="text-base">
              Em breve você receberá instruções para configurar seu Investe AI por email. 
              Seu assistente de investimentos gratuito no WhatsApp está chegando!
            </p>
            <div className="success-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">📧</span>
                <span>Receba instruções de configuração por email</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">🎁</span>
                <span>Acesso 100% gratuito e completo</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">🚀</span>
                <span>Seja notificado quando seu Investe AI estiver pronto</span>
              </div>
            </div>
            <button 
              onClick={handleClose}
              className="btn btn-secondary"
            >
              Fechar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Componente Hero Section
const HeroSection = ({ onOpenModal }) => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="title-xl animate-fade-in-up">
              O seu novo assistente de investimentos mora no WhatsApp.
            </h1>
            <p className="text-lg hero-subtitle animate-fade-in-up">
              Receba um podcast diário e converse com a nossa IA para ter o controle total da sua carteira, de forma simples e segura.
            </p>
            <div className="hero-cta animate-fade-in-up">
              <button onClick={onOpenModal} className="btn btn-primary">
                Quero meu Assistente de Investimentos Gratuito
              </button>
            </div>
          </div>
          <div className="hero-visual">
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="whatsapp-header">
                  <div className="header-left">
                    <div className="profile-pic">
                      <div className="profile-image">🤖</div>
                      <div className="online-indicator"></div>
                    </div>
                    <div className="contact-info">
                      <h3>Investe AI</h3>
                      <span>online</span>
                    </div>
                  </div>
                  <div className="header-right">
                    <div className="header-icon">📞</div>
                    <div className="header-icon">⋮</div>
                  </div>
                </div>
                <div className="chat-messages">
                  <div className="message ai-message">
                    <div className="message-content">
                      <strong>📊 Seu podcast diário está pronto!</strong><br/>
                      Hoje sua carteira teve +2.3% de performance...
                    </div>
                    <div className="message-time">14:32</div>
                  </div>
                  <div className="message user-message">
                    <div className="message-content">
                      Como estão minhas ações hoje?
                    </div>
                    <div className="message-time">14:33</div>
                  </div>
                  <div className="message ai-message">
                    <div className="message-content">
                      Sua carteira de ações está performando bem! A ação X subiu 1.2%...
                    </div>
                    <div className="message-time">14:33</div>
                  </div>
                </div>
                <div className="chat-input">
                  <div className="input-container">
                    <div className="input-icon">+</div>
                    <div className="input-field">
                      <span className="input-placeholder">Digite uma mensagem</span>
                    </div>
                  </div>
                </div>
                <div className="android-nav">
                  <div className="nav-dot"></div>
                  <div className="nav-dot"></div>
                  <div className="nav-dot"></div>
                </div>
              </div>
            </div>
            <div className="floating-icons">
              <div className="icon icon-1">📈</div>
              <div className="icon icon-2">🤖</div>
              <div className="icon icon-3">💰</div>
              <div className="icon icon-4">📊</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Problema e Solução
const ProblemSolutionSection = () => {
  return (
    <section className="problem-solution-section">
      <div className="container">
        <div className="section-content">
          <h2 className="title-lg section-title">Tempo é dinheiro. Conhecimento também.</h2>
          <div className="problem-solution-grid">
            <div className="problem-side">
              <h3 className="title-md">O problema que você conhece:</h3>
              <ul className="problem-list">
                <li>❌ Múltiplas plataformas para acompanhar</li>
                <li>❌ Informações dispersas e confusas</li>
                <li>❌ Tempo perdido analisando dados</li>
                <li>❌ Falta de insights personalizados</li>
                <li>❌ Dificuldade para tomar decisões rápidas</li>
              </ul>
            </div>
            <div className="solution-side">
              <h3 className="title-md">A solução que você precisa:</h3>
              <div className="solution-benefits">
                <div className="benefit-item">
                  <div className="benefit-icon">🎧</div>
                  <div className="benefit-content">
                    <h4>Podcast Diário</h4>
                    <p>O resumo perfeito para começar seu dia com insights sobre sua carteira.</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">💬</div>
                  <div className="benefit-content">
                    <h4>Chat Inteligente</h4>
                    <p>Pergunte sobre seus ativos, receba insights e explore novas oportunidades, tudo via WhatsApp.</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">🔒</div>
                  <div className="benefit-content">
                    <h4>Segurança Total</h4>
                    <p>Open Finance com criptografia de ponta para proteger seus dados.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Como Funciona
const HowItWorksSection = () => {
  const steps = [
    {
      number: "01",
      icon: "🔗",
      title: "Conecte suas contas",
      description: "Conecte todas as suas instituições financeiras de forma segura via Open Finance. Seus dados ficam protegidos com criptografia bancária."
    },
    {
      number: "02", 
      icon: "🎧",
      title: "Receba seu podcast",
      description: "Todos os dias, receba um podcast personalizado com análise completa da sua carteira. Fundos, ações, renda fixa - tudo resumido para você."
    },
    {
      number: "03",
      icon: "💬", 
      title: "Converse com a IA",
      description: "Faça perguntas sobre seus investimentos a qualquer momento. Nossa IA entende sua carteira e pode sugerir oportunidades."
    }
  ];

  return (
    <section className="how-it-works-section">
      <div className="container">
        <div className="section-content">
          <h2 className="title-lg section-title">Do zero ao investidor mais informado em 3 passos:</h2>
          <div className="steps-container">
            {steps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-number">{step.number}</div>
                <div className="step-icon">{step.icon}</div>
                <div className="step-content">
                  <h3 className="title-sm">{step.title}</h3>
                  <p className="text-base">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Preço
const PricingSection = ({ onOpenModal }) => {
  return (
    <section id="preco" className="pricing-section">
      <div className="container">
        <div className="section-content">
          <h2 className="title-lg section-title">A sua experiência de investimentos elevada.</h2>
          <div className="pricing-card">
            <div className="pricing-header">
              <h3 className="title-md">Investe AI</h3>
              <div className="price">
                <span className="amount">GRATUITO</span>
              </div>
            </div>
            <div className="pricing-features">
              <div className="feature-item">
                <span className="feature-icon">✅</span>
                <span>Podcast diário com análise completa (fundos, ações, renda fixa)</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✅</span>
                <span>Chat interativo e ilimitado para tirar dúvidas</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✅</span>
                <span>Instituições ilimitadas via Open Finance</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✅</span>
                <span>Suporte especializado via WhatsApp</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✅</span>
                <span>Acesso completo sem custos</span>
              </div>
            </div>
            <div className="pricing-cta">
              <button onClick={onOpenModal} className="btn btn-primary btn-large">
                Quero meu Assistente de Investimentos Gratuito
              </button>
              <p className="pricing-note">
                100% gratuito. Sem taxas ocultas. Sem compromisso.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente CTA Final
const FinalCTASection = ({ onOpenModal }) => {
  return (
    <section id="final-cta" className="final-cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 className="title-lg">Pronto para ter um especialista em investimentos sempre ao seu lado?</h2>
          <p className="text-lg cta-subtitle">
            Junte-se a centenas de investidores que já transformaram sua rotina de investimentos. 
            Tudo isso de forma 100% gratuita.
          </p>
          <div className="cta-buttons">
            <button onClick={onOpenModal} className="btn btn-primary btn-large">
              Quero meu Assistente de Investimentos Gratuito
            </button>
          </div>
          <div className="trust-indicators">
            <div className="trust-item">
              <span className="trust-icon">🔒</span>
              <span>100% Seguro</span>
            </div>
            <div className="trust-item">
              <span className="trust-icon">⚡</span>
              <span>Setup em 5 min</span>
            </div>
            <div className="trust-item">
              <span className="trust-icon">💬</span>
              <span>Suporte 24/7</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Footer
const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>Investe AI</h3>
            <p>Seu assistente de investimentos no WhatsApp</p>
          </div>
          <div className="footer-links">
            <a href="#privacidade">Política de Privacidade</a>
            <a href="#termos">Termos de Uso</a>
            <a href="#contato">Contato</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Investe AI. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

// Componente principal
const App = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (formData) => {
    console.log('Lead capturado:', formData);
    // Aqui você pode integrar com sua API de captura de leads
    // Exemplo: enviar para Mailchimp, RD Station, etc.
  };

  return (
    <div className="App">
      <HeroSection onOpenModal={handleOpenModal} />
      <ProblemSolutionSection />
      <HowItWorksSection />
      <PricingSection onOpenModal={handleOpenModal} />
      <FinalCTASection onOpenModal={handleOpenModal} />
      <Footer />
      
      <LeadCaptureModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleFormSubmit}
      />
    </div>
  );
};

export default App;
